<div class="f-row filled-action-row" *ngIf="CorporateHeading">
  <h6 class="title-subText m-bottom-8x">
    {{ content?.["b2b.register.companydetailstitle"] }}
  </h6>
  <a class="cursor-pointer" *ngIf="EditLink" (keydown.enter)="showCorporateInfoForm()" tabindex="0" role="button"
    (click)="showCorporateInfoForm()">{{content?.['b2b.register.edit']}}</a>
</div>

<form *ngIf="showForm" [formGroup]="corporateForm" (ngSubmit)="onSubmit()" class="form-info-section">
  <!-- demo code start -->
  <ng-container *ngIf="false">
    <div class="f-row">
      <div class="f-col">
        <mat-form-field appearance="fill" class="country-field">
          <mat-label>Country code</mat-label>
          <input matInput [formControl]="countryCtrl" [matAutocomplete]="auto" placeholder="Search country" />

          <mat-icon matSuffix>keyboard_arrow_down</mat-icon>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayCountry">
            <mat-option *ngFor="let country of (filteredCountries1 | async)" [value]="country">
              <div class="country-option">
                <img [src]="country.flag" [alt]="country.name" class="flag">
                <span class="country-name">
                  {{ country.name }}
                </span>
                <span class="country-code">
                  ({{ country.code }})
                </span>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
    <div class="f-row">
      <div class="f-col">
        <mat-form-field>
          <mat-label>Favorite food</mat-label>
          <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
          <mat-select>
            <mat-option *ngFor="let food of foods" [value]="food.value">{{food.viewValue}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <div class="f-row">
      <div class="f-col">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Select Agency</mat-label>
          <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
          <mat-select multiple [(value)]="selectedAgencies" class="custom-abc">
            <mat-select-trigger>
              <div class="selected-chips">
                <span class="custom-chip" *ngFor="let agency of selectedAgencies">
                  {{ agency }}
                  <mat-icon class="chip-close filled" (click)="$event.stopPropagation(); removeAgency(agency)">
                    cancel
                  </mat-icon>
                </span>
              </div>
            </mat-select-trigger>
            <mat-option *ngFor="let agency of agencies" [value]="agency">
              {{ agency }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </ng-container>
  <!-- demo code ends -->

  <div class="f-row">
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{ content?.["b2b.register.companyname"] }}</mat-label>
        <!-- <input matInput formControlName="companyName" /> -->
        <input matInput formControlName="companyName" (blur)="CheckCompany($event, 'NAME')"
          (keypress)="_CommonService.blockInvalidCharacters1($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (contextmenu)="_CommonService.disableRightClick($event)" (blur)="trimField('companyName')" />
        <!--   for duplicate cmp name check-->
        <mat-error
          *ngIf="corporateForm.get('companyName')?.hasError('required')">{{content?.dictionary?.['b2b.register.entercompanyname']}}</mat-error>
        <mat-error
          *ngIf="corporateForm.get('companyName')?.hasError('maxlength')">{{content?.dictionary?.['b2b.register.cannotexceedcompname']}}</mat-error>
        <mat-error *ngIf="
            corporateForm.get('companyName')?.hasError('noHtmlTagsValidator')
          ">{{content?.dictionary?.['b2b.register.entervalidinput']}}</mat-error>
        <mat-error
          *ngIf="corporateForm.get('companyName')?.hasError('CompanyExists')">{{content?.dictionary?.['b2b.register.companynameexists']}}</mat-error>
        <mat-error
          *ngIf="corporateForm.get('companyName')?.hasError('pattern')">{{content?.dictionary?.['b2b.register.entervalidinput']}}</mat-error>
        <mat-error
          *ngIf="corporateForm.get('companyName')?.hasError('minlength')">{{content?.dictionary?.['b2b.register.companyname4char']}}</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="f-row">
    <div class="f-col">
      <ng-select autoBlurSelect [items]="content?.['b2b.register.natureofbusinessdropdown']" bindLabel="Phrase"
        bindValue="Phrase" formControlName="natureOfBusiness" [placeholder]="content?.['b2b.register.natureofbusiness']"
        (keypress)="_CommonService.blockSpecialChar($event)">
      </ng-select>

      <!-- <mat-error class="px-4" *ngIf=" corporateForm.get('natureOfBusiness')?.invalid && corporateForm.get('natureOfBusiness')?.touched "> {{content?.dictionary?.['b2b.register.natureofbusinessdropdown']}}</mat-error> -->
      <mat-error class="px-4"
        *ngIf="corporateForm.get('natureOfBusiness')?.hasError('required') && corporateForm.get('natureOfBusiness')?.touched">
        Please select nature of business.
      </mat-error>

    </div>
  </div>

  <div class="f-row two--ColLayout">
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{content?.['b2b.register.companyregid']}} &nbsp;
          {{ message }}</mat-label>

        <input matInput formControlName="registrationId" data-dd-privacy="mask"
          (keypress)="_CommonService.blockSpecialChar($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (contextmenu)="_CommonService.disableRightClick($event)" (blur)="trimField('registrationId')" (blur)="CheckCompany($event, 'REGISTRATIONID')" />

        <mat-error
          *ngIf="corporateForm.get('registrationId')?.hasError('CompanyExists')">Registration ID already exists.</mat-error>

        <mat-error
          *ngIf="corporateForm.get('registrationId')?.hasError('required')">{{content?.dictionary?.['b2b.register.enterregid']}}</mat-error>

        <mat-error *ngIf="corporateForm.get('registrationId')?.hasError('pattern')"> Registration ID must be exactly 10
          digits. </mat-error>

        <mat-error
          *ngIf="corporateForm.get('registrationId')?.hasError('minlength')">{{content?.dictionary?.['b2b.register.regid8char']}}</mat-error>

        <mat-error
          *ngIf="corporateForm.get('registrationId')?.hasError('maxlength')">{{content?.dictionary?.['b2b.register.cannotexceedregid']}}</mat-error>

      </mat-form-field>
    </div>

    <div class="f-col">
      <mat-form-field>
        <mat-label>{{content?.['b2b.register.taxid']}} &nbsp; {{ message }}</mat-label>

        <input matInput formControlName="taxIdentifcationNo" data-dd-privacy="mask"
          (keypress)="_CommonService.allowNumberOnly($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (contextmenu)="_CommonService.disableRightClick($event)" (blur)="CheckCompany($event, 'TAX')" />

        <mat-error
          *ngIf="corporateForm.get('taxIdentifcationNo')?.hasError('CompanyExists')">Tax Identification Number already exists.</mat-error>

        <mat-error
          *ngIf="corporateForm.get('taxIdentifcationNo')?.hasError('required')">{{content?.dictionary?.['b2b.register.entertaxidno']}}</mat-error>

        <mat-error
          *ngIf="corporateForm.get('taxIdentifcationNo')?.hasError('minlength')">{{content?.dictionary?.['b2b.register.taxidno9char']}}</mat-error>

        <!-- <mat-error
          *ngIf="corporateForm.get('taxIdentifcationNo')?.hasError('maxlength')">{{content?.dictionary?.['b2b.register.cannotexceedtaxidno']}}</mat-error> -->

        <mat-error *ngIf="corporateForm.get('taxIdentifcationNo')?.hasError('maxlength')">Tax identification number
          cannot exceed 15 digits.</mat-error>

        <mat-error
          *ngIf="corporateForm.get('taxIdentifcationNo')?.hasError('pattern')">{{content?.dictionary?.['b2b.register.validtaxidno']}}</mat-error>

      </mat-form-field>
    </div>
  </div>

  <div class="f-row two--ColLayout">
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{content?.['b2b.register.empno']}}</mat-label>
        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select" [ngStyle]="{
            color: corporateForm.value.numberOfEmployee
              ? 'green'
              : 'rgba(0, 0, 0, 0.55)'
          }">stat_minus_1</mat-icon>
        <mat-select formControlName="numberOfEmployee" (keypress)="_CommonService.blockSpecialChar($event)">
          <mat-option *ngFor="let option of getSiteCoreArray('b2b.register.employeecount'); let i = index"
            [value]="option.Phrase" [ngClass]="{
              'mat-option-country-code-machted':
                (i == 0 && !corporateForm.value.numberOfEmployee) ||
                corporateForm.value.numberOfEmployee == option.Phrase
            }">
            {{ option.Phrase }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="corporateForm.get('numberOfEmployee')?.hasError('required')">
          {{content?.dictionary?.['b2b.register.selectnoofemp']}}
        </mat-error>
      </mat-form-field>
    </div>
    <div class="f-col">
      <div class="f-col" [formGroup]="stateForm">
        <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group" data-dd-privacy="mask"
          [searchFn]="_CommonService.customCountrySearchFn" formControlName="stateGroup" bindValue="isoCode"
          [placeholder]="content?.['b2b.register.country']" (change)="onNGSelectCountrySelected($event)"
          (keypress)="_CommonService.blockSpecialChar($event)">
          <ng-template ng-optgroup-tmp let-item="item">
            {{ item.group }}
          </ng-template>
          <ng-template ng-option-tmp let-item="item">
            <span class="ng-option-label">
              <ng-container *ngIf="!!item?.newFlag?.src">
                <img [src]="getImageUrl(item?.newFlag?.src)" alt="Flag of {{ item.countryName }}" class="flag-img"
                  [height]="item.height" [width]="item.width" />
              </ng-container>
              {{ item.countryName }}
            </span>
          </ng-template>
          <ng-template ng-label-tmp let-item="item">
            <span class="ng-value-label"> {{ item?.countryName }} </span>
          </ng-template>
          <ng-template ng-notfound-tmp>
            <!-- <div class="no-items-found">
              <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
              <p> {{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>

            </div> -->
            <div class="no-items-found">
              <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
              <p> {{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
              <span>Please check country name you have entered, or select one from the list</span>
            </div>

          </ng-template>
        </ng-select>
        <mat-error class="px-4" *ngIf="
            stateForm.get('stateGroup')?.invalid &&
            stateForm.get('stateGroup')?.touched
          ">
          {{content?.dictionary?.['b2b.register.selectcountry']}}
        </mat-error>
      </div>
    </div>
  </div>

  <div class="f-row two--ColLayout">

    <!-- district -->
    <div class="f-col">
      <mat-form-field>
        <mat-label>District</mat-label>
        <input matInput formControlName="district" (keypress)="_CommonService.blockSpecialChar($event)"
          (paste)="_CommonService.onPasteBlocked($event)" (contextmenu)="_CommonService.disableRightClick($event)" />
        <mat-error *ngIf="corporateForm.get('district')?.hasError('required')">
          District is required.
        </mat-error>
        <mat-error *ngIf="corporateForm.get('district')?.hasError('minlength')"> District should be at leaset 5
          characters.
        </mat-error>
        <mat-error *ngIf="corporateForm.get('district')?.hasError('maxlength')">District can't exceed more than 150
          characters.
        </mat-error>
      </mat-form-field>
    </div>

    <!-- city -->
    <div class="f-col">
      <ng-select autoBlurSelect [items]="filteredCities" formControlName="city" data-dd-privacy="mask"
        (change)="onNGSelectCitySelected($event)" bindValue="cityName" bindLabel="cityName"
        [placeholder]="content?.['b2b.register.city']" (keypress)="_CommonService.blockSpecialChar($event)">
        <ng-template ng-notfound-tmp>
          <div class="no-items-found">
            <img src="assets/images/not-found.png" alt="No items found" class="no-items-image" />
            <p> No city found</p>
            <span>{{content?.dictionary?.['b2b.register.checkselectedcity']}}</span>
          </div>
        </ng-template>
      </ng-select>
      <mat-error class="px-4" *ngIf="
          corporateForm.get('city')?.invalid &&
          corporateForm.get('city')?.touched
        ">
        {{content?.dictionary?.['b2b.register.selectcity']}}
      </mat-error>
    </div>
  </div>

  <div class="f-row two--ColLayout">
    <!-- postalcode -->
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{ content?.["b2b.register.postalcode"] }}</mat-label>
        <input matInput formControlName="PostalCode" data-dd-privacy="mask"
          (keypress)="_CommonService.allowNumberOnly($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (contextmenu)="_CommonService.disableRightClick($event)" />
        <mat-error *ngIf="corporateForm.get('PostalCode')?.hasError('required')">
          {{content?.dictionary?.['b2b.register.enterpostalcode']}}
        </mat-error>
        <mat-error *ngIf="corporateForm.get('PostalCode')?.hasError('minlength')">
          {{content?.dictionary?.['b2b.register.postalcode5char']}}
        </mat-error>
        <mat-error
          *ngIf="corporateForm.get('PostalCode')?.hasError('maxlength')">{{content?.dictionary?.['b2b.register.cannotexceedpostalcode']}}
        </mat-error>
      </mat-form-field>
    </div>

    <!-- building no -->
    <div class="f-col">
      <mat-form-field>
        <mat-label>Building Number</mat-label>
        <input matInput formControlName="BuildingNo" data-dd-privacy="mask"
          (keypress)="_CommonService.blockSpecialChar($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (contextmenu)="_CommonService.disableRightClick($event)" />
        <mat-error *ngIf="corporateForm.get('BuildingNo')?.hasError('required')">
          Building number is required.
        </mat-error>
        <!-- <mat-error *ngIf="corporateForm.get('PostalCode')?.hasError('minlength')"> {{content?.dictionary?.['b2b.register.postalcode5char']}}
        </mat-error> -->
        <mat-error *ngIf="corporateForm.get('BuildingNo')?.hasError('maxlength')">Building number can't exceed 15 digit.
        </mat-error>
        <mat-error *ngIf="corporateForm.get('BuildingNo')?.hasError('pattern')">Building number should be 4 digit
          only.</mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="f-row">
    <!-- street address -->
    <div class="f-col">
      <mat-form-field>
        <mat-label>Street Address</mat-label>
        <input matInput formControlName="headOfficeAddress" data-dd-privacy="mask"
          (keypress)="headOfcValidation($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (contextmenu)="_CommonService.disableRightClick($event)" (blur)="trimField('headOfficeAddress')" />
        <mat-error *ngIf="corporateForm.get('headOfficeAddress')?.hasError('required')">
          Street Address is required.
        </mat-error>
        <mat-error *ngIf="corporateForm.get('headOfficeAddress')?.hasError('maxlength')">
          Street address can't exceed more than 150 characters.
        </mat-error>
        <mat-error *ngIf="
            corporateForm
              .get('headOfficeAddress')
              ?.hasError('forbiddenCharacters')
          ">
          {{content?.dictionary?.['b2b.register.entervalidinput']}}
        </mat-error>
        <mat-error *ngIf="corporateForm.get('headOfficeAddress')?.hasError('minlength')">
          Street address can't less then 5 characters.
        </mat-error>
      </mat-form-field>
    </div>
  </div>


  <div class="f-row">
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{
          content?.["b2b.register.annualtravelbudget"]
          }}</mat-label>
        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">stat_minus_1</mat-icon>
        <mat-select formControlName="AnnualBudget" required (keypress)="_CommonService.blockInvalidCharacters($event)">
          <mat-option *ngFor="let option of getSiteCoreArray('b2b.register.travelbudgetlist'); let i = index"
            [value]="option.Phrase" [ngClass]="{
              'mat-option-country-code-machted':
                (i == 0 && !corporateForm.value.AnnualBudget) ||
                corporateForm.value.AnnualBudget == option.Phrase
            }">
            {{ option.Phrase }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="corporateForm.get('AnnualBudget')?.hasError('required')">
          {{content?.dictionary?.['b2b.register.selectestimatedtravelbudget']}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="f-row">
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{content?.['b2b.register.companyurl']}} (Optional)</mat-label>
        <input matInput formControlName="companyUrl" placeholder="https://www.abc.com"
          (keypress)="blockInvalidUrl($event)" (paste)="_CommonService.onPasteBlocked($event)"
          (contextmenu)="_CommonService.disableRightClick($event)" />
        <mat-error *ngIf="corporateForm.get('companyUrl')?.hasError('minlength')">
          {{content?.dictionary?.['b2b.register.url5char']}}
        </mat-error>
        <mat-error *ngIf="corporateForm.get('companyUrl')?.hasError('maxlength')">
          {{content?.dictionary?.['b2b.register.cannotexceedurl']}}
        </mat-error>
        <mat-error *ngIf="corporateForm.get('companyUrl')?.hasError('pattern')">
          {{content?.dictionary?.['b2b.register.validurl']}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="f-row">
    <div class="f-col">
      <div class="f-row validation-col radio-group-container">
        <label class="mat-label" for="Do you have Company Domain: ">{{content?.['b2b.register.companydomain']}}</label>

        <mat-radio-group formControlName="hasCompanyDomain">
          <mat-radio-button [value]="true">{{content?.['b2b.register.yes']}}</mat-radio-button>
          <mat-radio-button [value]="false">{{content?.['b2b.register.no']}}</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>
  </div>

  <div class="f-row" *ngIf="corporateForm.get('hasCompanyDomain')?.value === true">
    <div class="f-col col-username">
      <p>{{ content?.["b2b.register.username"] }}</p>
    </div>
    <div class="f-col">
      <mat-form-field>
        <mat-label>{{ content?.["b2b.register.domaintext"] }}</mat-label>

        <input matInput formControlName="domainName" (keypress)="_CommonService.blockInvalidCharacters1($event)"
          (paste)="_CommonService.onPasteBlocked($event)" (contextmenu)="_CommonService.disableRightClick($event)" />

        <!-- errors here -->
        <mat-error *ngIf="corporateForm.get('domainName')?.hasError('required')">
          {{content?.dictionary?.['b2b.register.entercompdomain']}}
        </mat-error>
        <mat-error *ngIf="corporateForm.get('domainName')?.hasError('maxlength')">
          {{content?.dictionary?.['b2b.register.cannotexceedcompdomain']}}
        </mat-error>
        <mat-error *ngIf="
            corporateForm.get('domainName')?.hasError('noHtmlTagsValidator')
          ">
          {{content?.dictionary?.['b2b.register.entervalidinput']}}
        </mat-error>
        <mat-error *ngIf="
            corporateForm.get('domainName')?.hasError('pattern') &&
            corporateForm.get('domainName')?.touched
          ">
          {{content?.dictionary?.['b2b.register.validdomaininput']}}
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  <div class="f-row justify-end m-top-8x">
    <button mat-button class="button--secondary-small" [disabled]="
        corporateForm.invalid ||
        stateForm.invalid ||
        (corporateForm.get('hasCompanyDomain')?.value === true &&
          !corporateForm.get('domainName')?.value)
      " [ngClass]="{
        disabled:
          corporateForm.invalid ||
          stateForm.invalid ||
          (corporateForm.get('hasCompanyDomain')?.value === true &&
            !corporateForm.get('domainName')?.value)
      }" type="submit">
      {{content?.['b2b.register.save']}}
    </button>
  </div>
</form>

<!-- *ngIf="Shub" -->

<div class="form-fill-list" *ngIf="EditLink">
  <div class="corporatelist">
    <div class="corp-detail">
      <div class="info-section">
        {{ content?.["b2b.register.companyname"] }}
      </div>
      <div class="info-type">{{ submittedData?.companyName }}</div>
    </div>
    <div class="corp-detail">
      <div class="info-section">
        {{ content?.["b2b.register.natureofbusiness"] }}
      </div>
      <div class="info-type">
        {{ submittedData?.natureOfBusiness || "-" }}
      </div>
    </div>
    <div class="corp-detail">
      <div class="info-section">
        {{ content?.["b2b.register.companyregid"] }}
      </div>
      <div class="info-type">{{ submittedData?.registrationId || "-" }}</div>
    </div>
    <div class="corp-detail">
      <div class="info-section">{{ content?.["b2b.register.taxid"] }}</div>
      <div class="info-type">
        {{ submittedData?.taxIdentifcationNo || "-" }}
      </div>
    </div>
    <div class="corp-detail">
      <div class="info-section">{{ content?.["b2b.register.empno"] }}</div>
      <div class="info-type">
        {{ getViewValue(submittedData?.numberOfEmployee, content?.["b2b.register.employeecount"] ) }}
      </div>
    </div>
    <div class="corp-detail">
      <div class="info-section">{{ content?.["b2b.register.country"] }}</div>
      <div class="info-type">
        {{ PreviousCountry }}
      </div>
    </div>

    <div class="corp-detail">
      <div class="info-section">District</div>
      <div class="info-type">
        {{ submittedData?.district }}
      </div>
    </div>


    <div class="corp-detail">
      <div class="info-section">{{ content?.["b2b.register.city"] }}</div>
      <div class="info-type">
        <div>{{ selectedCity }}</div>
      </div>
    </div>

    <div class="corp-detail">
      <div class="info-section">{{ content?.["b2b.register.postalcode"] }}</div>
      <div class="info-type">{{ submittedData?.PostalCode }}</div>
    </div>

    <div class="corp-detail">
      <div class="info-section">
        Building Number
      </div>
      <div class="info-type">{{ submittedData?.BuildingNo }}</div>
    </div>

    <div class="corp-detail">
      <div class="info-section">
        Street Address
      </div>
      <div class="info-type">{{ submittedData?.headOfficeAddress }}</div>
    </div>

    <div class="corp-detail">
      <div class="info-section">
        {{ content?.["b2b.register.annualtravelbudget"] }}
      </div>
      <div class="info-type">
        {{ getViewValue(submittedData?.AnnualBudget, content?.["b2b.register.travelbudgetlist"]) }}
      </div>
    </div>
    <div class="corp-detail">
      <div class="info-section">{{ content?.["b2b.register.companyurl"] }}</div>
      <div class="info-type">{{ submittedData?.companyUrl || "-" }}</div>
    </div>
    <div class="corp-detail">
      <div class="info-section">
        {{ content?.["b2b.register.companydomaintext"] }}
      </div>
      <div class="info-type">{{ submittedData?.domainName || "-" }}</div>
    </div>
  </div>
</div>